(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
var e_1, _a;
// Veelgestelde vragen en ZAV (components/faqTopics.cshtml) en de vragen in de zoekresultaten (Zoeken.cshtml).
// Per .js-faq: onderwerpen (.js-faq--topic) wisselen het zichtbare onderwerp (article); vragen (.js-item) klappen open
// via de vraag (dt). Er staat steeds één vraag open: de eerste van het eerste onderwerp bij het laden.
var Faq = /** @class */ (function () {
    function Faq(root) {
        var e_2, _a, e_3, _b, e_4, _c;
        var _this = this;
        this.root = root;
        var topics = Array.from(root.querySelectorAll('.js-faq--topic'));
        var articles = Array.from(root.querySelectorAll('article'));
        this.items = Array.from(root.querySelectorAll('.js-item'));
        try {
            // Onderwerpkoppen in de artikelen zijn alleen voor schermlezers; de onderwerpenlijst staat ernaast
            for (var _d = __values(Array.from(root.querySelectorAll('.js-accessibility'))), _e = _d.next(); !_e.done; _e = _d.next()) {
                var heading = _e.value;
                heading.style.display = 'none';
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
            }
            finally { if (e_2) throw e_2.error; }
        }
        var _loop_1 = function (item) {
            item.classList.remove('active');
            var question = item.querySelector('dt');
            if (!question) {
                return "continue";
            }
            question.setAttribute('role', 'button');
            question.setAttribute('tabindex', '0');
            question.addEventListener('click', function () { return _this.toggle(item); });
            question.addEventListener('keydown', function (event) {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    _this.toggle(item);
                }
            });
        };
        try {
            for (var _f = __values(this.items), _g = _f.next(); !_g.done; _g = _f.next()) {
                var item = _g.value;
                _loop_1(item);
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
            }
            finally { if (e_3) throw e_3.error; }
        }
        var _loop_2 = function (topic) {
            topic.addEventListener('click', function (event) {
                var e_5, _a, e_6, _b;
                event.preventDefault();
                var target = root.querySelector('#' + topic.getAttribute('aria-controls'));
                try {
                    for (var articles_1 = __values(articles), articles_1_1 = articles_1.next(); !articles_1_1.done; articles_1_1 = articles_1.next()) {
                        var article = articles_1_1.value;
                        article.style.display = article === target ? '' : 'none';
                    }
                }
                catch (e_5_1) { e_5 = { error: e_5_1 }; }
                finally {
                    try {
                        if (articles_1_1 && !articles_1_1.done && (_a = articles_1.return)) _a.call(articles_1);
                    }
                    finally { if (e_5) throw e_5.error; }
                }
                var wasActive = topic.classList.contains('active');
                try {
                    for (var topics_2 = __values(topics), topics_2_1 = topics_2.next(); !topics_2_1.done; topics_2_1 = topics_2.next()) {
                        var t = topics_2_1.value;
                        t.classList.remove('active');
                        t.setAttribute('aria-expanded', 'false');
                    }
                }
                catch (e_6_1) { e_6 = { error: e_6_1 }; }
                finally {
                    try {
                        if (topics_2_1 && !topics_2_1.done && (_b = topics_2.return)) _b.call(topics_2);
                    }
                    finally { if (e_6) throw e_6.error; }
                }
                if (!wasActive) {
                    topic.classList.add('active');
                    topic.setAttribute('aria-expanded', 'true');
                }
            });
        };
        try {
            for (var topics_1 = __values(topics), topics_1_1 = topics_1.next(); !topics_1_1.done; topics_1_1 = topics_1.next()) {
                var topic = topics_1_1.value;
                _loop_2(topic);
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (topics_1_1 && !topics_1_1.done && (_c = topics_1.return)) _c.call(topics_1);
            }
            finally { if (e_4) throw e_4.error; }
        }
        // Begintoestand: eerste onderwerp zichtbaar en actief, met de eerste vraag open
        articles.forEach(function (article, i) { article.style.display = i === 0 ? '' : 'none'; });
        if (topics.length) {
            topics[0].classList.add('active');
            topics[0].setAttribute('aria-expanded', 'true');
        }
        var firstItem = articles.length ? articles[0].querySelector('.js-item') : null;
        if (firstItem) {
            this.toggle(firstItem);
        }
    }
    Faq.prototype.toggle = function (item) {
        var e_7, _a;
        var open = !item.classList.contains('active');
        try {
            for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                var other = _c.value;
                other.classList.remove('active');
                this.setExpanded(other, false);
            }
        }
        catch (e_7_1) { e_7 = { error: e_7_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_7) throw e_7.error; }
        }
        if (open) {
            item.classList.add('active');
            this.setExpanded(item, true);
        }
    };
    Faq.prototype.setExpanded = function (item, expanded) {
        var question = item.querySelector('dt');
        if (question) {
            question.setAttribute('aria-expanded', String(expanded));
        }
    };
    return Faq;
}());
try {
    for (var _b = __values(Array.from(document.querySelectorAll('.js-faq'))), _c = _b.next(); !_c.done; _c = _b.next()) {
        var root = _c.value;
        new Faq(root);
    }
}
catch (e_1_1) { e_1 = { error: e_1_1 }; }
finally {
    try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
    }
    finally { if (e_1) throw e_1.error; }
}
},{}],2:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Alle gedrag van de site, zonder jQuery. Elke module zoekt zelf zijn elementen op en doet niets als die er niet zijn.
require("./menu");
require("./search");
require("./overview");
require("./faq");
require("./slider");
require("./video");
require("./storyScroll");
require("./readspeaker");
},{"./faq":1,"./menu":3,"./overview":4,"./readspeaker":5,"./search":6,"./slider":7,"./storyScroll":8,"./video":9}],3:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Mobiel menu (off-canvas) — zonder jQuery.
// Open/dicht via de hamburgerknop (.c-nav-toggle); sluit bij klik op de pagina, Escape of zodra het venster
// desktopbreedte (1024px) bereikt, want daar staat het menu gewoon in de header.
var body = document.body;
var toggle = document.querySelector('.c-nav-toggle');
var desktop = window.matchMedia('(min-width: 1024px)');
function setOpen(open) {
    body.classList.toggle('is-activeNav', open);
    if (toggle) {
        toggle.setAttribute('aria-expanded', String(open));
    }
}
if (toggle) {
    toggle.setAttribute('aria-expanded', 'false');
    toggle.addEventListener('click', function (event) {
        event.preventDefault();
        setOpen(!body.classList.contains('is-activeNav'));
    });
}
var main = document.querySelector('main');
if (main) {
    main.addEventListener('click', function () { return setOpen(false); });
}
document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && body.classList.contains('is-activeNav')) {
        setOpen(false);
        if (toggle) {
            toggle.focus();
        }
    }
});
desktop.addListener(function (event) {
    if (event.matches) {
        setOpen(false);
    }
});
},{}],4:[function(require,module,exports){
"use strict";
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
var e_1, _a;
// Filterbare overzichten (actueelBlock, projectenBlock): keuzelijsten (.js-filter select), zoekveld (.js-zoekveld)
// en paginering (.js-pagination) in de browser. Per sectie .js-haspagination; kaarten zijn .js-item met data-values
// (komma-gescheiden: type, locatie, status). Keuzelijsten en zoekveld werken samen.
var PAGE_SIZE = 6;
var MAX_BUTTONS = 5;
var Overview = /** @class */ (function () {
    function Overview(section) {
        var e_2, _a;
        var _this = this;
        this.page = 1;
        this.items = Array.from(section.querySelectorAll('.js-item'));
        this.selects = Array.from(section.querySelectorAll('.js-filter select'));
        this.search = section.querySelector('.js-zoekveld');
        this.pagination = section.querySelector('.js-pagination');
        this.visible = this.items;
        try {
            for (var _b = __values(this.selects), _c = _b.next(); !_c.done; _c = _b.next()) {
                var select = _c.value;
                select.addEventListener('change', function () { return _this.apply(); });
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
        if (this.search) {
            this.search.addEventListener('input', function () { return _this.apply(); });
        }
        if (this.pagination) {
            this.pagination.addEventListener('click', function (event) {
                var button = event.target.closest('.pagination-btn');
                if (button && !button.disabled) {
                    _this.show(Number(button.getAttribute('data-page')));
                }
            });
        }
        this.show(1);
    }
    /** Filtert op alle gekozen waarden én alle zoekwoorden, en begint weer op pagina 1. */
    Overview.prototype.apply = function () {
        var values = this.selects.map(function (s) { return s.value.toLowerCase(); }).filter(function (v) { return v; });
        var keywords = (this.search ? this.search.value : '').toLowerCase().trim().split(/\s+/).filter(function (k) { return k; });
        this.visible = this.items.filter(function (item) {
            var itemValues = (item.getAttribute('data-values') || '').toLowerCase().split(',').map(function (v) { return v.trim(); });
            var text = (item.textContent || '').toLowerCase();
            return values.every(function (v) { return itemValues.indexOf(v) >= 0; }) && keywords.every(function (k) { return text.indexOf(k) >= 0; });
        });
        this.show(1);
    };
    Overview.prototype.show = function (page) {
        var e_3, _a;
        this.page = page;
        var start = (page - 1) * PAGE_SIZE;
        var current = this.visible.slice(start, start + PAGE_SIZE);
        try {
            for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                var item = _c.value;
                item.style.display = current.indexOf(item) >= 0 ? '' : 'none';
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_3) throw e_3.error; }
        }
        this.renderButtons();
    };
    /** Vorige, maximaal 5 paginanummers rond de huidige pagina, volgende. Geen knoppen bij één pagina. */
    Overview.prototype.renderButtons = function () {
        if (!this.pagination) {
            return;
        }
        var total = Math.ceil(this.visible.length / PAGE_SIZE);
        if (total <= 1) {
            this.pagination.innerHTML = '';
            return;
        }
        var start = Math.max(1, this.page - Math.floor(MAX_BUTTONS / 2));
        var end = Math.min(total, start + MAX_BUTTONS - 1);
        start = Math.max(1, end - MAX_BUTTONS + 1);
        var nav = function (page, icon, disabled) {
            return "<button class=\"pagination-btn pagination-btn--nav\" data-page=\"" + page + "\" " + (disabled ? 'disabled' : '') + "><span class=\"material-symbols-outlined\">" + icon + "</span></button>";
        };
        var html = nav(this.page - 1, 'arrow_left_alt', this.page === 1);
        for (var i = start; i <= end; i++) {
            html += "<button class=\"pagination-btn" + (i === this.page ? ' active' : '') + "\" data-page=\"" + i + "\"><span>" + i + "</span></button>";
        }
        html += nav(this.page + 1, 'arrow_right_alt', this.page === total);
        this.pagination.innerHTML = html;
    };
    return Overview;
}());
try {
    for (var _b = __values(Array.from(document.querySelectorAll('.js-haspagination'))), _c = _b.next(); !_c.done; _c = _b.next()) {
        var section = _c.value;
        new Overview(section);
    }
}
catch (e_1_1) { e_1 = { error: e_1_1 }; }
finally {
    try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
    }
    finally { if (e_1) throw e_1.error; }
}
},{}],5:[function(require,module,exports){
"use strict";
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
var e_1, _a;
// Translate-knop naast "Lees voor" (Views/Partials/components/readspeaker.cshtml): opent de uitleg
// "How to translate text" (Views/Partials/components/translateHelp.cshtml, één <dialog> per pagina).
// Vertalen zelf gaat via ReadSpeaker (tekst selecteren → 'Vertalen'); zonder ReadSpeaker blijft de knop verborgen.
// Sluiten: kruisje, Escape (standaard bij <dialog>) of klik naast de pop-up.
var dialog = document.getElementById('rs-translate-help');
var buttons = Array.from(document.querySelectorAll('.js-rs-translate'));
var readSpeakerLoaded = !!window.rspkr;
if (dialog && typeof dialog.showModal === 'function' && readSpeakerLoaded) {
    var opener_1 = null;
    var _loop_1 = function (button) {
        button.hidden = false;
        button.setAttribute('aria-controls', dialog.id);
        button.addEventListener('click', function () {
            opener_1 = button;
            dialog.showModal();
        });
    };
    try {
        for (var buttons_1 = __values(buttons), buttons_1_1 = buttons_1.next(); !buttons_1_1.done; buttons_1_1 = buttons_1.next()) {
            var button = buttons_1_1.value;
            _loop_1(button);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (buttons_1_1 && !buttons_1_1.done && (_a = buttons_1.return)) _a.call(buttons_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    var close_1 = dialog.querySelector('.js-rs-translate-close');
    if (close_1) {
        close_1.addEventListener('click', function () { return dialog.close(); });
    }
    // Klik op de achtergrond (buiten de inhoud) sluit de pop-up
    dialog.addEventListener('click', function (event) {
        if (event.target === dialog) {
            dialog.close();
        }
    });
    // Focus terug naar de knop waarmee de pop-up geopend werd
    dialog.addEventListener('close', function () {
        if (opener_1) {
            opener_1.focus();
        }
    });
}
},{}],6:[function(require,module,exports){
"use strict";
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
var e_1, _a, e_2, _b;
// Zoekvenster (Views/Partials/blocks/search.cshtml): openen via elke .js-zoek-link (metamenu en mobiel menu),
// sluiten via .js-zoekenClose of Escape. Bij openen krijgt het zoekveld de focus.
var panel = document.querySelector('.c-zoeken');
function setOpen(open) {
    if (!panel) {
        return;
    }
    panel.classList.toggle('is-open', open);
    if (open) {
        var input = panel.querySelector('input[type="search"]');
        if (input) {
            input.focus();
        }
    }
}
try {
    for (var _c = __values(Array.from(document.querySelectorAll('.js-zoek'))), _d = _c.next(); !_d.done; _d = _c.next()) {
        var link = _d.value;
        link.addEventListener('click', function (event) {
            event.preventDefault();
            setOpen(true);
        });
    }
}
catch (e_1_1) { e_1 = { error: e_1_1 }; }
finally {
    try {
        if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
    }
    finally { if (e_1) throw e_1.error; }
}
try {
    for (var _e = __values(Array.from(document.querySelectorAll('.js-zoekenClose'))), _f = _e.next(); !_f.done; _f = _e.next()) {
        var button = _f.value;
        button.addEventListener('click', function () { return setOpen(false); });
    }
}
catch (e_2_1) { e_2 = { error: e_2_1 }; }
finally {
    try {
        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
    }
    finally { if (e_2) throw e_2.error; }
}
document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && panel && panel.classList.contains('is-open')) {
        setOpen(false);
    }
});
},{}],7:[function(require,module,exports){
"use strict";
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
var e_1, _a, e_2, _b;
function arrows(scope) {
    return {
        nextEl: scope ? scope.querySelector('.swiper-button-next') : null,
        prevEl: scope ? scope.querySelector('.swiper-button-prev') : null,
    };
}
if (typeof Swiper !== 'undefined') {
    try {
        // Blijf op de hoogte: 1 kaart op mobiel en tablet (tekst naast de foto), 2 vanaf 1024px
        for (var _c = __values(Array.from(document.querySelectorAll('.swiper-actueel .swiper'))), _d = _c.next(); !_d.done; _d = _c.next()) {
            var el = _d.value;
            new Swiper(el, {
                slidesPerView: 1,
                spaceBetween: 20,
                navigation: arrows(el.closest('.swiper-actueel')),
                breakpoints: {
                    320: { slidesPerView: 1, spaceBetween: 20 },
                    769: { slidesPerView: 1, spaceBetween: 24 },
                    1024: { slidesPerView: 2, spaceBetween: 24 },
                },
            });
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        }
        finally { if (e_1) throw e_1.error; }
    }
    try {
        // Fotogalerij: gecentreerd, 3 foto's vanaf 640px
        for (var _e = __values(Array.from(document.querySelectorAll('.swiper--alt'))), _f = _e.next(); !_f.done; _f = _e.next()) {
            var el = _f.value;
            new Swiper(el, {
                direction: 'horizontal',
                centeredSlides: true,
                centeredSlidesBounds: true,
                navigation: arrows(el.closest('.swiper-gallery')),
                breakpoints: {
                    320: { slidesPerView: 1, spaceBetween: 20 },
                    640: { slidesPerView: 3, spaceBetween: 24 },
                },
            });
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
        }
        finally { if (e_2) throw e_2.error; }
    }
}
},{}],8:[function(require,module,exports){
"use strict";
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
var e_1, _a;
// Story scroll (blocklist/Components/storyScroll.cshtml), naar het voorbeeld van de story-scroll op retool.com.
// Het blok staat vast (sticky) zodra het het scherm vult; doorscrollen gaat dan binnen het blok: elke 60vh wordt het
// volgende item actief (tekst klapt open, afbeeldingen schuiven mee). Na het laatste item laat het blok los.
// Klik op een titel of stip scrollt naar dat item. Zonder JavaScript staan alle items open (geen .is-enhanced).
var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
var STEP = 0.6; // scrollafstand per item als deel van de schermhoogte (gelijk aan $story-step in blocks/_story-scroll.scss)
var GAP = 28; // ruimte tussen de afbeeldingen in px ($story-image-gap)
var INACTIVE_SCALE = 0.9; // niet-actieve afbeeldingen zijn 90% breed (en dus 90% hoog) op desktop
var desktop = window.matchMedia('(min-width: 1024px)');
var StoryScroll = /** @class */ (function () {
    function StoryScroll(section) {
        var _this = this;
        this.section = section;
        this.current = -1;
        this.ticking = false;
        this.items = Array.from(section.querySelectorAll('.c-story__item'));
        this.images = Array.from(section.querySelectorAll('.c-story__image'));
        this.dots = Array.from(section.querySelectorAll('.c-story__dot'));
        // De scrollbaan is de ouder van het vastgezette paneel
        var inner = section.querySelector('.c-story__inner');
        this.track = inner && inner.parentElement ? inner.parentElement : section;
        section.classList.add('is-enhanced');
        this.items.forEach(function (item, i) {
            var trigger = item.querySelector('.c-story__trigger');
            if (trigger) {
                trigger.addEventListener('click', function () { return _this.goTo(i); });
            }
        });
        this.dots.forEach(function (dot, i) { return dot.addEventListener('click', function () { return _this.goTo(i); }); });
        var request = function () {
            if (_this.ticking) {
                return;
            }
            _this.ticking = true;
            window.requestAnimationFrame(function () {
                _this.ticking = false;
                _this.update();
            });
        };
        // capture op document: vangt ook scroll-events van een andere scroll-container dan het venster
        document.addEventListener('scroll', request, { passive: true, capture: true });
        window.addEventListener('resize', request);
        this.update();
    }
    /** Hoe ver de scrollbaan al voorbij de bovenkant van het scherm is, in stappen van 60vh. */
    StoryScroll.prototype.update = function () {
        var passed = -this.track.getBoundingClientRect().top;
        var index = Math.floor(passed / (window.innerHeight * STEP));
        this.activate(Math.max(0, Math.min(this.items.length - 1, index)));
        this.position();
    };
    /**
     * Desktop: verticale positie per afbeelding t.o.v. het kader. De actieve staat op 0; de andere zijn kleiner
     * (INACTIVE_SCALE) en staan erboven (vorige) of eronder (volgende), steeds GAP px ertussen.
     */
    StoryScroll.prototype.position = function () {
        var _this = this;
        var media = this.section.querySelector('.c-story__media');
        if (!desktop.matches || !media) {
            return;
        }
        var active = media.getBoundingClientRect().height;
        var small = active * INACTIVE_SCALE;
        this.images.forEach(function (image, i) {
            var d = i - _this.current;
            var y = d === 0 ? 0 : d > 0 ? active + GAP + (d - 1) * (small + GAP) : d * (small + GAP);
            image.style.setProperty('--story-y', Math.round(y) + 'px');
        });
    };
    StoryScroll.prototype.activate = function (index) {
        if (index === this.current) {
            return;
        }
        this.current = index;
        this.section.style.setProperty('--story-index', String(index));
        var toggle = function (list) { return list.forEach(function (el, i) { return el.classList.toggle('is-active', i === index); }); };
        toggle(this.items);
        toggle(this.images);
        toggle(this.dots);
        this.items.forEach(function (item, i) {
            var trigger = item.querySelector('.c-story__trigger');
            if (trigger) {
                trigger.setAttribute('aria-expanded', String(i === index));
            }
        });
        this.dots.forEach(function (dot, i) {
            if (i === index) {
                dot.setAttribute('aria-current', 'true');
            }
            else {
                dot.removeAttribute('aria-current');
            }
        });
    };
    /** Scrollt naar het midden van de stap van item i (het blok staat dan vast met dat item actief). */
    StoryScroll.prototype.goTo = function (index) {
        var step = window.innerHeight * STEP;
        var trackTop = window.pageYOffset + this.track.getBoundingClientRect().top;
        window.scrollTo({ top: trackTop + (index + 0.5) * step, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
    };
    return StoryScroll;
}());
try {
    for (var _b = __values(Array.from(document.querySelectorAll('.js-story'))), _c = _b.next(); !_c.done; _c = _b.next()) {
        var section = _c.value;
        new StoryScroll(section);
    }
}
catch (e_1_1) { e_1 = { error: e_1_1 }; }
finally {
    try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
    }
    finally { if (e_1) throw e_1.error; }
}
},{}],9:[function(require,module,exports){
"use strict";
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
var e_1, _a;
var _loop_1 = function (container) {
    var button = container.querySelector('.c-btn--video');
    var iframe = container.querySelector('iframe');
    if (!button || !iframe) {
        return "continue";
    }
    button.addEventListener('click', function () {
        var src = iframe.getAttribute('src');
        if (!src || container.classList.contains('is-playing')) {
            return;
        }
        iframe.setAttribute('src', src + (src.indexOf('?') >= 0 ? '&' : '?') + 'autoplay=1');
        container.classList.add('is-playing');
        button.style.display = 'none';
    });
};
try {
    // Videoblok (blocklist/Components/video.cshtml): afspeelknop over een ingesloten video (iframe).
    // Bij klikken komt autoplay=1 in de URL van de iframe en verdwijnt de knop. Werkt per video, ook met meerdere op een pagina.
    for (var _b = __values(Array.from(document.querySelectorAll('.u-video'))), _c = _b.next(); !_c.done; _c = _b.next()) {
        var container = _c.value;
        _loop_1(container);
    }
}
catch (e_1_1) { e_1 = { error: e_1_1 }; }
finally {
    try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
    }
    finally { if (e_1) throw e_1.error; }
}
},{}]},{},[2])

